export const getUnreadLabel = (count?: number | null) => {
  if (!count) return null;
  const safeCount = Math.max(0, count);
  if (safeCount === 0) return null;
  if (safeCount > 99) {
    return '99+';
  }
  return `${safeCount}`;
};

